import React from 'react';
import { useHistory } from 'react-router-dom';
import useUser from 'hooks/useUser';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExitIcon from '@material-ui/icons/ExitToApp';
import HomeIcon from '@material-ui/icons/Home';
import ReceiptIcon from '@material-ui/icons/Receipt';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useZoomScale from 'hooks/useZoomScale';
const defaultFontSize = 24;

const useStyles = makeStyles(theme => ({
  list: {
    backgroundColor: theme.palette.background.paper,
  },
  listItem: {
    paddingRight: 100
  }
}))

const routes = [
  
  {
    path: '/manage',
    text: 'Manage Jobs',
    icon: EmojiPeopleIcon,
    role: 'tech.admin'
  },
  {
    path: '/swap',
    text: 'Swap Schedules',
    icon: ReceiptIcon,
    role: 'tech.admin'
  },
  {
    type: 'delimiter',
    role: 'tech.admin'
  },
  {
    path: '/home',
    text: 'Home',
    icon: HomeIcon
  },
  {
    path: '/state-forms',
    text: 'State Forms', 
    icon: ReceiptIcon
  }
]

function SideBar({ open, toggleDrawer }) {
  const { user, setUser } = useUser();
  const history = useHistory();
  const styles = useStyles();
  const scale = Math.min(useZoomScale(), 1);

  const drawerAction = action => () => {
    action();
    toggleDrawer();
  }

  const logout = drawerAction(() => {
    localStorage.removeItem('accessToken');
    setUser(null);
    history.push('/login');
  })


  return (
    <Drawer 
      anchor='left' 
      open={open} 
      onClose={toggleDrawer}
    >
      <Box p={2}>
        <Typography variant="h4" component="h2">Red Code Mobile</Typography>
      </Box>
      <List className={styles.list}>
        {!!user && routes.filter(route => route.role ? route.role === user?.role : true).map((route, i) => (
          route.type === 'delimiter' ?
          <Divider key={i} />
          :
          <React.Fragment key={route.path}>
            <ListItem button onClick={drawerAction(() => history.push(route.path))} className={styles.listItem} style={{ fontSize: defaultFontSize / scale }}>
              <ListItemIcon>
                <route.icon style={{ fontSize: defaultFontSize / scale }} />
              </ListItemIcon>
              <ListItemText primary={route.text} style={{ fontSize: defaultFontSize / scale }} />
            </ListItem>
          </React.Fragment>
        ))}

        {/* <ListItem button onClick={drawerAction(() => history.push('/state-forms'))} className={styles.listItem} >
          <ListItemIcon>
            <ReceiptIcon style={{ fontSize: defaultFontSize / scale }}/>
          </ListItemIcon>
          <ListItemText primary='State Forms' style={{ fontSize: defaultFontSize / scale }} />
        </ListItem> */}

        <ListItem button onClick={logout} className={styles.listItem} >
          <ListItemIcon>
            <ExitIcon style={{ fontSize: defaultFontSize / scale }}/>
          </ListItemIcon>
          <ListItemText primary='Log Out' style={{ fontSize: defaultFontSize / scale }} />
        </ListItem>
      </List>
    </Drawer>
  );
}

export default SideBar;